import React from 'react';
import { connect } from 'react-redux';
import { TextField, Grid, Stack, Button } from '@mui/material';
import Swal from 'sweetalert2';

import { API } from 'aws-amplify';

import ErrorView from '../error';
import { open, close } from '../../features/loading/loadingSlice';
import { change, next, reset, setQueryResult } from '../../features/entry/entrySlice';

const Step1TextField = (props) => {
  return (
    <TextField fullWidth margin='normal' {...props} />
  );
}

const Step1 = (props) => {
  const validatePhone = (target) => {
    var value = target.value;
    if (value === '') {
      props.change({ name: 'phoneHelperText', value: '' });
      props.change({ name: 'phoneError', value: false });
    } else {
      var result = value.match(/^\d*$/);
      if (result === null) {
        props.change({ name: 'phoneHelperText', value: '数字のみ、ハイフン不要' });
        props.change({ name: 'phoneError', value: true });
      } else {
        props.change({ name: 'phoneHelperText', value: '' });
        props.change({ name: 'phoneError', value: false });
      }
    }
  };

  const next = () => {
    let data = { body: { operation: 'getEntry', phone: props.entry.phone } };
    props.open();
    API.post('uabingoapi', '/entry', data)
      .then(response => {
        props.close();
        if (response.data !== null) {
          Swal.fire({
            html: '<b>入力された社員番号は、すでにこのイベントに登録されていますが、登録情報を更新しますか？</b>',
            showCancelButton: true,
            icon: 'info',
            confirmButtonText: '更新する',
            cancelButtonText: '戻す',
            confirmButtonColor: '#33ab9f',
          }).then((result) => {
            if (result.isConfirmed) {
              props.setQueryResult(response.data)
              props.next(props.entry.activeStep);
            }
          });
        } else {
          props.next(props.entry.activeStep);
        }
      })
      .catch(error => {
        props.close();
        ErrorView(error.response.data.message);
      });
  }

  const nextDisabled = !props.entry.user_name || !props.entry.office || !props.entry.phone || !props.entry.employee_no || props.entry.phoneError;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Step1TextField required label='氏名' name='user_name' value={props.entry.user_name} onChange={(event) => { props.change(event.target) }} />
        <Step1TextField required label='事業所名' name='office' value={props.entry.office} onChange={(event) => { props.change(event.target) }} />
        <Step1TextField required label='事業所電話番号（ハイフンなし）' name='phone' value={props.entry.phone} onChange={(event) => { props.change(event.target) }} 
          helperText={props.entry.phoneHelperText} onBlur={(event) => { validatePhone(event.target) }} error={props.entry.phoneError} />
        <Step1TextField required label='社員番号' name='employee_no' value={props.entry.employee_no} onChange={(event) => { props.change(event.target) }} />
        </Grid>
      <Grid item xs={6}></Grid>
      <Grid item xs={6}>
        <Stack direction='row' spacing={2} justifyContent='flex-end'>
          <Button variant='contained' color='primary' type='reset' onClick={() => { props.reset() }}>リセット</Button>
          <Button disabled={nextDisabled} variant='contained' color='primary' type='submit' onClick={next}>次へ</Button>
        </Stack>
      </Grid>
    </Grid>
  );
}

/** react-redux */
const mapStateToProps = (state) => {
  return {
    entry: state.entry,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    open: () => dispatch(open()),
    close: () => dispatch(close()),
    change: (...args) => dispatch(change(...args)),
    next: (activeStep) => dispatch(next(activeStep)),
    reset: () => dispatch(reset()),
    setQueryResult: (data) => dispatch(setQueryResult(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Step1);